import { useEffect } from 'react';

import { VIEW_TITLES } from '../routes';

// Titre de l'onglet en fonction de la page affichée.
export function useDocumentTitle({ appState }) {
  useEffect(() => {
    document.title = VIEW_TITLES[appState.view]
      ? `${VIEW_TITLES[appState.view]} — Plan de charge`
      : 'Plan de charge — Uptime';
  }, [appState.view]);
}
